const audioPlayer = "_35saqre16s";
const image = "_35simdg9ju";

export { audioPlayer, image };
import "./input.image.style.linaria.module.css";
//# sourceMappingURL=input.image.style.js.map
